
/**
 * @fileoverview Radio component React interface.
 * @author Lisa Liu (lliu@yext.com)
 */
goog.declareModuleId('yext.ui.components.Radio');

import {classNames} from '/ui/lib/classnames';
import {useUid} from '/ui/lib/uid';

const elemRoot = 'yext-radio';
const radioRoot = `${elemRoot}__radio`;
const labelRoot = `${elemRoot}__label`;

// Leniancy to be resolved in Part 2
// Value can be boolean
// src/com/yext/m4/confcode/adminconsole/js/businessselectormodal/businessselectormodal.js:45 and 53

/**
 * @param {{
 *   helpText?: React.ReactNode,
 *   id?: string,
 *   label: (React.ReactNode),
 *   name?: string,
 *   onBlur?: Function,
 *   onChange?: Function,
 *   onFocus?: Function,
 *   tid?: string,
 *   pendoId?: string,
 *   value: (string|boolean),
 *   checked?:  boolean,
 *   disabled?: boolean,
 *   hideLabel?: boolean,
 *   readOnly?: boolean,
 *   inputElementRef?: ?,
 * }} props
 * @returns {React.ReactElement}
 */
export function Radio({
  checked = false,
  disabled = false,
  helpText,
  hideLabel = false,
  id = '',
  label,
  name,
  onBlur,
  onChange,
  onFocus,
  readOnly = false,
  tid,
  pendoId,
  value,
  inputElementRef,
}) {
  const labelTextClasses = classNames(
    `${labelRoot}-text`,
    {
      [`${labelRoot}-text--hidden`]: hideLabel,
    },
  );

  const labelTextMarkup = (
    <span className={labelTextClasses}>{label}</span>
  );

  const labelContentClasses = classNames(
    `${labelRoot}-content`,
    {
      [`${labelRoot}-content--hidden`]: hideLabel,
    },
  );

  const labelContentMarkup = helpText ? (
    <div className={labelContentClasses}>
      {labelTextMarkup}
      <small className={`${labelRoot}-help-text`}>{helpText}</small>
    </div>
  ) : labelTextMarkup;

  const radioIconMarkup = (
    <span className={`${radioRoot}-icon--checked`}></span>
  );

  const uid = useUid();

  return (
    <div className={`${elemRoot}__container`} tid={tid}>
      <label
        htmlFor={id || uid}
        className={`${labelRoot}`}
      >
        <span className={`${radioRoot}-container`}>
          <input
            className={radioRoot}
            checked={checked}
            disabled={disabled}
            id={id || uid}
            name={name}
            onBlur={onBlur}
            onChange={onChange}
            onFocus={onFocus}
            readOnly={readOnly}
            type="radio"
            value={value}
            ref={inputElementRef}
            data-pendo={pendoId}
          />
          <span className={`${radioRoot}-control`}></span>
          <span className={`${radioRoot}-icon`}>
            {radioIconMarkup}
          </span>
        </span>
        {labelContentMarkup}
      </label>
    </div>
  );
}
